import { toast } from "react-hot-toast";

export const showToast = (type, message, delay = 0) => {
  if (!message) return;

  if (delay > 0) {
    window.setTimeout(() => {
      toast[type](message);
    }, delay);
    return;
  }

  toast[type](message);
};
